




























































































import $ from 'jquery';
import {
    EventBus,
    hasElements,
    TypeEventBus,
    sortObjectByPropertyName,
    checkIfIDExistsInArray,
    existItemInList
} from '../../core/utils';
import ListWithItems from '../../core/components/ListWithItems.vue';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import { PRIVILEGE_KEYS, PRIVILEGE_TYPES } from '../../core/utils/privileges';
import  Combobox from '../../core/components/Combobox.vue';
import  Input from '../../core/components/Input.vue';
import {
    MsgBox,
    PlusEyeButtons,
    Breadcrums,
    CloseConfirmationModal
} from '../../core/components';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import multiselect from 'vue-multiselect';
import Axios from 'axios';
import Loading from 'vue-loading-overlay';
import { config } from 'rxjs';

@Component({
    components: {
        multiselect,
        Loading,
        Combobox,
        PlusEyeButtons,
        Breadcrums,
        ListWithItems,
        CloseConfirmationModal,
        Input
    }
})
export default class ModalCheckboxList extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    @Prop({default(){return []}}) ranchsIds: string[];
    @Prop({default(){return []}}) formatOptions: Array<object>;
    @Prop({default(){return []}}) extensionOptions: Array<object>;
    @Prop({default: 960}) modalWidth: number;
    @Prop({default: {}}) listOptions: object;
    @Prop({default: false}) visible: boolean;
    @Prop({default: false}) showFormats: boolean;
    @Prop({default: true}) canSave: boolean;
    @Prop({default: true}) showNameColumn: boolean;
    @Prop({default: ''}) defaultFileName: string;
    @Prop({default: 'Exportar'}) modalTitle: string;
    @Prop({default: 'Descargar'}) downloadBtn: string;
    visibleModal: boolean = false;
    pendingRequest: boolean = false;
    fileName: string = '';
    formatSelected: object | null = null;
    formatSelectedRv: boolean = false;

    updateFormatSelected(value){
        this.formatSelected = value;
    }
    updateFormatSelectedRv(value){
        this.formatSelectedRv = value;
    }

    updateFileName(value){
        this.fileName = value;
    }

    @Emit()
    checkedItem(item) {
        return item;
    }

    get existAnySelectedOption(){
        return existItemInList(Object.values(this.listOptions), 'checked', true)
    }

    @Watch('fileName')
    observableDescription(value) {
        if (value == null) {
            this.fileName = '';
        }
    }

    @Emit()
    saveAction(fileName: string, optionsSelected: Array<string>, formatSelected: object | null) {}

    //methods
    mounted() {
        this.handleListenKey(true);
        this.fileName = this.defaultFileName;
        this.visibleModal = this.visible;
    }

    closeModal() {
        this.$emit('close-modal', false);
        this.handleListenKey(false);
    }

    handleListenKey(value: boolean) {
        if (value) {
            this.$_disableListenkey();
        } else {
            this.$_enableListenkey();
        }
    }

    triggerSubmit() {
        let filterOptionsSelected = Object.values(this.listOptions)
            .filter(item => item['checked'] == true)
            .map(function(item) {
                return item['key'];
            });

        this.saveAction(this.fileName, filterOptionsSelected, this.formatSelected);
        this.closeModal();
    }

    get checkIfFormIsValid() {
        if (this.showNameColumn && this.fileName === '') {
            return false;
        }

        if (!this.existAnySelectedOption) {
            return false;
        }

        if(this.showFormats && this.formatSelected == null){
            return false
        }

        return true;
    }
}
